module.exports = {"getError":"Pri načítaní histórie entít nastala chyba"}